// MobileNav.js
import React, { useState } from 'react';
import { X, Menu } from 'lucide-react';
import Logo from './Logo';
import { navItems } from './navItems';

const MobileNav = ({ onNavigate, currentPath }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    return (
        <>
            <header className="fixed top-0 left-0 right-0 bg-gradient-to-b from-[#bebebe] to-[#b6b6b6] shadow-lg z-50">
                <div className="flex items-center justify-between px-4 py-3">
                    <Logo expanded={true} />
                    <button
                        onClick={() => setIsMenuOpen(!isMenuOpen)}
                        className="p-2 rounded-lg bg-white/50 hover:bg-white/70 text-blue-900"
                        aria-label="Toggle menu"
                    >
                        {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
                    </button>
                </div>

                {isMenuOpen && (
                    <nav className="border-t border-blue-900">
                        {navItems.map((item) => (
                            <button
                                key={item.path}
                                onClick={() => {
                                    onNavigate(item.path);
                                    setIsMenuOpen(false);
                                }}
                                className={`w-full flex items-center px-6 py-4 gap-3
                                    ${currentPath === item.path
                                        ? 'bg-blue-900 text-white'
                                        : 'text-blue-900 hover:bg-white/50'}`}
                            >
                                {item.icon}
                                <span className="font-medium">{item.label}</span>
                            </button>
                        ))}
                    </nav>
                )}
            </header>
            <div className="h-14" />
        </>
    );
};

export default MobileNav;
